<template>
  <div>
      <h1 class="text-center mb-5">Card Payment</h1>
      <div v-if="!isLoading">
        <p class="text-center subhead mb-3 maxwidth640 center-block">Enter your payment information</p>
        <v-layout row wrap>
          <v-flex md6 offset-md3 class="add-new-card-container">
            <v-layout row wrap>
              <v-flex md12 class="add-new-card-header">
                <h4>Card Details:</h4>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex md12>
                <div>
                  <v-layout>
                    <v-flex md8 offset-md2>
                      <div class="mt-4">
                        <OnlineRenewalCardDetails v-show="isMounted" :publishable-key="publishableKey" ref="cardDetailsRef"></OnlineRenewalCardDetails>
                      </div>
                    </v-flex>
                  </v-layout>
                </div>
              </v-flex>
            </v-layout>
            <br />
          </v-flex>
        </v-layout>
        <br />
        <v-layout>
          <v-flex md4 offset-md4>
            <button class="green-button" @click="proceedWithPayment()" :disabled="validating">PAY ${{totalPayable}}</button>
          </v-flex>
        </v-layout>
      </div>
      <div v-else>
        <div class="text-center">
          <v-progress-circular indeterminate color="blue"></v-progress-circular>
        </div>
      </div>
  </div>
</template>

<script>
import IconArrowBack from "@/components/icons/arrowBack.vue";
import IconBase from "@/components/IconBase.vue";
import IconForwardBack from "@/components/icons/arrowForward.vue";
import IconCheck from "@/components/icons/check.vue";
import Globals from "@/assets/scripts/global-functions.js";
import BackButton from "@/components/BackButton.vue";
import NextButton from "@/components/forms/ButtonNext.vue";
import OnlineRenewalCardDetails from "@/components/OnlineRenewalCardDetails.vue";

export default {
  $_veeValidate: {
    validator: "new"
  },
  name: "NewBusinessPayment",
  components: {
    IconArrowBack,
    IconBase,
    IconCheck,
    IconForwardBack,
    BackButton,
    NextButton,
    OnlineRenewalCardDetails
  },
  data: () => ({
    isMounted: false,
    isLoading: true,
    publishableKey: null,
    validating: false,
    idempotencyKey: "",
    errorStripe: 0
  }),
  props: ["totalPayable", "quoteId"],
  computed: {
    GenerateIdempotencyKey(){
      return `${this.$store.state.sessionDetails.id}-${this.$store.state.quoteDetails.id}`
    },
    AllFieldsValid: function() {
      let _isvalid = false;

      return _isvalid;
    }
  },
  methods: {
    async proceedWithPayment() {
      this.validating = true;
      if(this.errorStripe == 1){
        this.idempotencyKey = await this.generateIdempotencyKey();
      }else{
        this.idempotencyKey = this.GenerateIdempotencyKey;
      }

      const token = await this.$refs["cardDetailsRef"].createToken()
      if (token.state) {
        let request = {
          currency: "AUD",
          quote_id: this.$store.state.quoteDetails.id.toString(),
          description: "FDCA Policy Payment - 1 pcs",
          statement_description: "",
          source: token.result.id,
          idempotency_key: this.idempotencyKey,
          metadata: {
            base_url: this.baseURL,
            // description: this.idempotencyKey,
            description: `${this.$store.state.sessionDetails.id}-${this.$store.state.quoteDetails.id}`,
            transactions_api_token: this.transactionsAPIToken,
            type: 'quick_quote',
            env: this.environment,
            user_id: this.$store.state.sessionDetails.user_id,
            user_type: this.$store.state.sessionDetails.properties.user_type,
            business_name: this.$store.state.sessionDetails.properties.business_name,
            add_ons_cover: this.$store.state.sessionDetails.properties.additional_cover_code,
            package_code: this.$store.state.sessionDetails.properties.package_code,
            start_date: this.$store.state.sessionDetails.properties.policy_start,
            end_date: this.$store.state.sessionDetails.properties.policy_expiry,
            service_information: "",
            post_all_documents: this.$store.state.sessionDetails.properties.post_all_documents,
            registered_for_gst: this.$store.state.sessionDetails.properties.registered_for_gst,
            abn: this.$store.state.sessionDetails.properties.abn,
            registered_service: "",
            policy_type: this.$store.state.sessionDetails.properties.policy_type,
            membership_output_membership_base: "",
            membership_output_membership_base_gst: "",
            membership_tl_addon_base: "",
            membership_tl_addon_base_gst: "",
            membership_dr_addon_base: "",
            membership_dr_addon_base_gst: "",
            membership_addons_base: "",
            membership_addons_base_gst: "",
            membership_addons_total: "",
            user_id: this.$store.state.sessionDetails.properties.user_id,
            transaction_type: this.$store.state.sessionDetails.properties.transaction_type
          }
        }

        let payload = {
            method: "post",
            url: `${this.baseURL}/api/fdca/cfw/payment/add.json`,
            data: request
          },
          response = await this.$store.dispatch("fetchData", payload),
          errors = response.data.api_call_send.response.body.includes("error") ? 1 : 0;

        if (errors === 0) {
          let updateSessionStatusResponse = await this.$store.dispatch( "fetchData", {
              method: location.origin === "http://localhost:8080" ? "get" : "put",
              url: `/api/fdca/cfw/sessions/update_session_status.json`,
              data: {
                id: this.$store.state.sessionDetails.id,
                session_status: "closed"
              }
            }
          );

          this.$router.push("/purchase-policy/result")
        } else {
          //errors.forEach(error => this.filterError(error.message))
          let message = JSON.parse(response.data.api_call_send.response.body);
          this.validating = false;
          Swal.fire({
            type: 'error',
            title: 'Error',
            text: message.error.message,
            allowOutsideClick: false
          });
          this.errorStripe = 1;
          
        }
      } else {
        this.validating = false;
        if(!token.state){
          parent.toastr.error(token.result)
        }
      }
    },
    init: async function() {
      if (!InsitesGatewaySettings.get().hasLoaded) {
        var state = await InsitesGatewaySettings.load();
        if (state) {
          this.settings = InsitesGatewaySettings.get();
          this.isMounted = true;
        }
      } else {
        this.settings = InsitesGatewaySettings.get();
        this.isMounted = true;
      }
    },
    async generateIdempotencyKey() {
      const request = {
        token: document.getElementsByName('cmb-api-token')[0].content,
        token_name: "cmb-auth",
        quote_id: this.$store.state.quoteDetails.id.toString()
      };
      let generate_idempotency_key = await this.$store.dispatch( "fetchData", {
              method: "put",
              url: `main/update_quotes_idempotency_key.json`,
              data: request
            }
          );

      return generate_idempotency_key.data.items.idempotency_key;   

    },
    filterError: function(err) {
      let message = err;
      if (err.includes("Invalid API Key")) {
        message = "Invalid API Key.";
      } else if (err.includes("No such customer")) {
        message = "Your account was not found on the Gateway.";
      } else if (
        err.includes("No such source") ||
        err.includes("No such token")
      ) {
        message = "Your card was not found on the Gateway.";
      }
      message += " Please contact the website administrator.";
      Swal.fire({
        type: 'error',
        title: 'Error',
        text: message,
        allowOutsideClick: false
      })
    },
    
    async fetchStripeKey() {
        let payload = {
            method: 'get',
            url: `/api/fdca/cfw/stripe/get-public-key.json`
        },
        response = await this.$store.dispatch('fetchData', payload)
        this.publishableKey = response.data.settings.livemode ? response.data.pk_live_key : response.data.pk_test_key;
        this.isLoading = false;
        this.isMounted = true;
        setTimeout(() => {
          this.$refs.cardDetailsRef.onMount()
        }, 200);
    }
  },
  mounted() {
    this.fetchStripeKey()
  }
};
</script>

<style>
.add-new-card-container {
  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);
}
.add-new-card-header {
  display: flex;
  align-items: center;
  justify-content: center;
}
.add-new-card-buton {
  color: #0072bc;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 10px 20px;
  font-weight: bold;
  text-transform: uppercase;
}
.add-new-card-buton svg {
  margin-left: 10px;
  height: 30px;
  width: 30px;
}
.credit-card-item{
  padding-bottom: 20px;
}
.card-element-container label{
    font-size: 14px;
    font-weight: 600;
    color: #2c3148;
    margin-bottom: 2px;
}

.StripeElement {
    -webkit-box-shadow: none;
    box-shadow: none;
    font-family: Open Sans,sans-serif;
    font-size: 16px;
    font-weight: 400;
    border: 1px solid #F0F1F3;
    color: #2c3148;
    border-radius: 4px;
    margin-bottom: 20px;
    padding: 15px;
    -webkit-transition: border-color .25s ease-in-out,-webkit-box-shadow .5s;
    transition: border-color .25s ease-in-out,-webkit-box-shadow .5s;
    transition: box-shadow .5s,border-color .25s ease-in-out;
    transition: box-shadow .5s,border-color .25s ease-in-out,-webkit-box-shadow .5s;
    width: 100%;
    background-color: #fff;
}
</style>